import { createAction } from '@ngrx/store';

export const retryPayingByDirectDebit = createAction(
  '[CheckoutCardPaymentComponent] Retry paying by direct debit instead of card'
);
